import React, { useEffect, useState } from 'react';
import Header from '../../layouts/Header';
import { Col, Row, Form, Button, Container, Card, Alert, ListGroup, Spinner } from 'react-bootstrap';
import axiosInstance from '../../api/axios';import { toast } from 'react-toastify';
import Select from "react-select";
import makeAnimated from "react-select/animated";

const AddSubscription = () => {
    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);

    const accessToken = localStorage.getItem("authToken");
    const animatedComponents = makeAnimated();
    const [formData, setFormData] = useState({
        title: '',
        subTitle: '',
        description: '',
        subscriptionType: '',
        termsConditions: [],
        subscriptionWorking: [],
        applicableCategories: [],
        excludedDays: [],
        // applicableOrderValues: { min: 0, max: '' },
        redemptionInterval: '',
        duration: '',
        price: '',
        taxPercent: '',
        banner: null,
        otherImage: null,
        excludedOutlets: [],
        excludedProducts: [],
        excludedAddonValues: [],
        orderThreshold: '',
        orderQuantity: ''
    });
    const [categoryList, setCategoryList] = useState([]);
    const [outletList, setOutletList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [addonList, setAddonList] = useState([]);
    const [previewImages, setPreviewImages] = useState({
        banner: null,
        otherImage: null
    });
    const [errors, setErrors] = useState({});
    const [submitStatus, setSubmitStatus] = useState({
        success: false,
        message: ''
    });
    const [newTerm, setNewTerm] = useState('');
    const [newWork, setNewWork] = useState('');
    const [isAddBtnLoading, setIsAddBtnLoading] = useState(false);
    const [selectedAddonGroups, setSelectedAddonGroups] = useState([]);
    const [filteredAddonValues, setFilteredAddonValues] = useState([]);

    const daysOfWeek = [
        'Monday', 'Tuesday', 'Wednesday', 'Thursday',
        'Friday', 'Saturday', 'Sunday'
    ];

    const getCategoryList = async() => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("masters/category/get", { headers });
            console.log("Response :", response);
        
            if (response?.data?.status === true) {
                console.log("Categories Data:", response?.data?.data?.categories);
                const categories = response?.data?.data?.categories;
                console.log("Categories :", categories);
                
                setCategoryList(categories);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                    toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getOutletList = async() => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("outlet", { headers });
            if (response?.data?.status === true) {
                const filteredOutlets = response?.data?.data?.outlets.filter((act) => act?.status === "ACTIVE");
                setOutletList(filteredOutlets);
            }
        } catch (error) {
            toast.error(error.response?.data?.error || "Failed to fetch outlets", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        }
    };

    const getProductList = async(categoryIds) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("product", { headers });
            // if (response?.data?.status === true) {
            //     setProductList(response?.data?.data?.products);
            // }
            if (response?.data?.status === true) {
                let allProducts = response?.data?.data?.products;

                // Filter products if categoryIds are passed
                allProducts = allProducts?.filter(product =>
                    categoryIds?.includes(product?.category?._id)
                );
                if (allProducts.length > 0 ) {
                    setProductList(allProducts);
                } else {
                    setProductList(response?.data?.data?.products);
                }
            }
        } catch (error) {
            toast.error(error.response?.data?.error || "Failed to fetch products", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        }
    };

    const getAddonList = async() => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("addons?page=1&limit=50", { headers });
            if (response?.data?.status === true) {
                console.log("Response of addons :", response?.data?.data);
                
                setAddonList(response?.data?.data?.addons);
            }
        } catch (error) {
            toast.error(error.response?.data?.error || "Failed to fetch addons", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleNestedChange = (parent, name, value) => {
        setFormData(prev => ({
            ...prev,
            [parent]: {
                ...prev[parent],
                [name]: value
            }
        }));
    };

    const handleCheckboxChange = (field, value, isChecked) => {
        setFormData(prev => ({
            ...prev,
            [field]: isChecked 
                ? [...prev[field], value] 
                : prev[field].filter(item => item !== value)
        }));
    };

    const handleImageChange = (e, field) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({
                ...prev,
                [field]: file
            }));

            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImages(prev => ({
                    ...prev,
                    [field]: reader.result
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    const addTerm = () => {
        if (newTerm.trim()) {
            setFormData(prev => ({
                ...prev,
                termsConditions: [...prev.termsConditions, newTerm.trim()]
            }));
            setNewTerm('');
            // Clear any existing error
            setErrors(prev => ({ ...prev, termsConditions: null }));
        }
    };

    const removeTerm = (index) => {
        setFormData(prev => ({
            ...prev,
            termsConditions: prev.termsConditions.filter((_, i) => i !== index)
        }));
    };

    const addWork = () => {
        if (newWork.trim()) {
            setFormData(prev => ({
                ...prev,
                subscriptionWorking: [...prev.subscriptionWorking, newWork.trim()]
            }));
            setNewWork('');
            // Clear any existing error
            setErrors(prev => ({ ...prev, subscriptionWorking: null }));
        }
    };

    const removeWork = (index) => {
        setFormData(prev => ({
            ...prev,
            subscriptionWorking: prev.subscriptionWorking.filter((_, i) => i !== index)
        }));
    };

    const validateForm = () => {
        const newErrors = {};

        // Required fields validation
        if (!formData.title.trim()) newErrors.title = 'Title is required';
        if (!formData.subTitle.trim()) newErrors.subTitle = 'Subtitle is required';
        if (!formData.description.trim()) newErrors.description = 'Description is required';
        if (formData.termsConditions.length === 0) newErrors.termsConditions = 'At least one term & condition is required';
        if (formData.applicableCategories.length === 0) newErrors.applicableCategories = 'Select at least one category';
        // if (!formData.redemptionInterval) newErrors.redemptionInterval = 'Redemption interval is required';
        if (!formData.duration) newErrors.duration = 'Duration is required';
        if (!formData.price) newErrors.price = 'Price is required';
        if (!formData.taxPercent) newErrors.taxPercent = 'Tax is required';
        if (!formData.banner) newErrors.banner = 'Banner image is required';

        // Numeric validation
        // if (formData.redemptionInterval && formData.redemptionInterval < 1) 
        //     newErrors.redemptionInterval = 'Must be at least 1';
        // if (formData.duration && formData.duration < 1) 
        //     newErrors.duration = 'Must be at least 1';
        if (formData.price && formData.price < 0) 
            newErrors.price = 'Price cannot be negative';
        if (formData.taxPercent && (formData.taxPercent < 0 || formData.taxPercent > 100)) 
            newErrors.taxPercent = 'Tax must be between 0-100%';

        // Order values validation
        // if (formData.applicableOrderValues.min < 0) 
        //     newErrors.applicableOrderValues = { ...newErrors.applicableOrderValues, min: 'Minimum must be 0 or more' };
        // if (formData.applicableOrderValues.max && 
        //     formData.applicableOrderValues.max < formData.applicableOrderValues.min) 
        //     newErrors.applicableOrderValues = { ...newErrors.applicableOrderValues, max: 'Max must be greater than min' };

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // const handleSelectChange = (fieldName, selectedOptions) => {
    //     if (fieldName === "applicableCategories") {
    //         const catIds = selectedOptions.map(option => option.value); // Extract category IDs
    //         getProductList(catIds); // Pass IDs to filter products
    //     }
    //     console.log("Filed name :", fieldName, "selectedOptions", selectedOptions)
    //     // Convert selected options back to your original objects
    //     let selectedItems = [];
        
    //     if (fieldName === 'applicableCategories') {
    //         selectedItems = selectedOptions 
    //             ? categoryList.filter(category => 
    //                 selectedOptions.some(option => option.value === category._id)
    //             )
    //             : [];
    //     } else if (fieldName === 'excludedOutlets') {
    //         selectedItems = selectedOptions 
    //             ? outletList.filter(outlet => 
    //                 selectedOptions.some(option => option.value === outlet._id)
    //             )
    //             : [];
    //     } else if (fieldName === 'excludedProducts') {
    //         selectedItems = selectedOptions 
    //             ? productList.filter(product => 
    //                 selectedOptions.some(option => option.value === product._id)
    //             )
    //             : [];
    //     } else if (fieldName === 'excludedAddonValues') {
    //         selectedItems = selectedOptions 
    //             ? addonList.filter(addon => 
    //                 selectedOptions.some(option => option.value === addon._id)
    //             )
    //             : [];
    //     }
        
    //     setFormData(prev => ({
    //         ...prev,
    //         [fieldName]: selectedItems
    //     }));

    //     // Clear error when user selects something
    //     if (selectedItems.length > 0 || selectedOptions === null) {
    //         setErrors(prev => ({
    //             ...prev,
    //             [fieldName]: null
    //         }));
    //     }
    // };

    const handleSelectChange = (fieldName, selectedOptions) => {
        console.log("Field name:", fieldName, "selectedOptions:", selectedOptions);

        let selectedItems = [];

        if (fieldName === 'applicableCategories') {
            const catIds = selectedOptions.map(option => option.value);
            getProductList(catIds);

            selectedItems = categoryList.filter(category =>
            selectedOptions.some(option => option.value === category._id)
            );
        } else if (fieldName === 'excludedOutlets') {
            selectedItems = outletList.filter(outlet =>
            selectedOptions.some(option => option.value === outlet._id)
            );
        } else if (fieldName === 'excludedProducts') {
            selectedItems = productList.filter(product =>
            selectedOptions.some(option => option.value === product._id)
            );
        } else if (fieldName === 'excludedAddonGroups') {
            // Update the selected groups
            setSelectedAddonGroups(selectedOptions);

            // Generate the addon values options based on selected groups
            const addonValuesOptions = selectedOptions?.flatMap(option => {
            const addon = addonList?.find(a => a._id === option.value);
            return addon?.addonValues?.map(val => ({
                value: {
                addonId: addon._id,
                addValueId: val._id
                },
                label: `${addon.title} - ${val.value}`
            }));
            });

            setFilteredAddonValues(addonValuesOptions);
            
            // Also update the formData with selected groups
            selectedItems = addonList.filter(addon =>
            selectedOptions.some(option => option.value === addon._id)
            );
        }

        setFormData(prev => ({
            ...prev,
            [fieldName]: selectedItems
        }));

        if (selectedItems.length > 0 || selectedOptions === null) {
            setErrors(prev => ({
            ...prev,
            [fieldName]: null
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsAddBtnLoading(true);
        if (validateForm()) {
            try {
                const formDataToSend = new FormData();

                Object.keys(formData).forEach(key => {
                    if (
                        key === 'applicableCategories' || 
                        key === 'excludedDays' || 
                        key === 'termsConditions' || 
                        key === 'subscriptionWorking' || 
                        key === 'excludedOutlets' || 
                        key === 'excludedProducts' ||
                        key === 'excludedAddonGroups'  // Added excludedAddonGroups here
                    ) {
                        formData[key]?.forEach((item, index) => {
                            const value = typeof item === 'object' && item !== null ? item._id : item;
                            formDataToSend.append(`${key}[${index}]`, value);
                        });
                    } 
                    else if (key === 'excludedAddonValues') {
                        // Special handling for addon values to include both addonId and addValueId
                        formData[key]?.forEach((item, index) => {
                            formDataToSend.append(`${key}[${index}][addonId]`, item.addonId);
                            formDataToSend.append(`${key}[${index}][addValueId]`, item.addValueId);
                        });
                    }
                    else if (key === 'banner' || key === 'otherImage') {
                        if (formData[key]) {
                            formDataToSend.append(key, formData[key]);
                        }
                    } else {
                        if (formData[key] !== null && formData[key] !== undefined) {
                            formDataToSend.append(key, formData[key]);
                        }
                    }
                });
                
                // Append all form data using the same pattern as handleSubmitEdit
                // Object.keys(formData).forEach(key => {
                //     if (
                //         key === 'applicableCategories' || 
                //         key === 'excludedDays' || 
                //         key === 'termsConditions' || 
                //         key === 'subscriptionWorking' || 
                //         key === 'excludedOutlets' || 
                //         key === 'excludedProducts' ||
                //         key === 'excludedAddonGroups'
                //     ) {
                //         formData[key]?.forEach((item, index) => {
                //             const value = typeof item === 'object' && item !== null ? item._id : item;
                //             formDataToSend.append(`${key}[${index}]`, value);
                //         });
                //     } 
                //     else if (key === 'excludedAddonValues') {
                //         // Special handling for addon values to include both addonId and addValueId
                //         formData[key]?.forEach((item, index) => {
                //             formDataToSend.append(`${key}[${index}][addonId]`, item.addonId);
                //             formDataToSend.append(`${key}[${index}][addValueId]`, item.addValueId);
                //         });
                //     }
                //     else if (key === 'banner' || key === 'otherImage') {
                //         if (formData[key]) {
                //             formDataToSend.append(key, formData[key]);
                //         }
                //     } else {
                //         if (formData[key] !== null && formData[key] !== undefined) {
                //             formDataToSend.append(key, formData[key]);
                //         }
                //     }
                // });

                const headers = {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'multipart/form-data'
                };
                
                const response = await axiosInstance.post("subscription", formDataToSend, { headers });
                
                setSubmitStatus({
                    success: true,
                    message: 'Subscription created successfully!'
                });

                if (response?.data?.status === true) {
                    toast.success(response?.data?.data?.message, {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "light",
                    });
                }
                
                // Reset form
                setFormData({
                    title: '',
                    subTitle: '',
                    description: '',
                    subscriptionType: '',
                    termsConditions: [],
                    subscriptionWorking: [],
                    applicableCategories: [],
                    excludedDays: [],
                    redemptionInterval: '',
                    duration: '',
                    price: '',
                    taxPercent: '',
                    banner: null,
                    otherImage: null,
                    excludedOutlets: [],
                    excludedProducts: [],
                    excludedAddonValues: [],
                    excludedAddonGroups: [],
                    orderThreshold: '',
                    orderQuantity: ''
                });
                
                setPreviewImages({ banner: null, otherImage: null });
                setErrors({});
                setNewTerm('');
                setNewWork('');
                setSelectedAddonGroups([]);
                setFilteredAddonValues([]);
                
            } catch (error) {
                console.error('Error creating subscription:', error);
                if (error?.response) {
                    let errorMessage = '';
                    if (error.response?.status === 406) {
                        errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                    }
                    else if (error.response?.status === 412) {
                        errorMessage = error?.response?.data?.data?.message;
                    } else if (error.response?.status === 400) {
                        errorMessage = error?.response?.data?.error;
                    } else if (error.response?.status === 500) {
                        errorMessage = error?.response?.data?.message;
                    }
            
                    toast.error(errorMessage, {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "colored",
                    });
                }
                setSubmitStatus({
                    success: false,
                    message: error.response?.data?.message || 'Error creating subscription. Please try again.'
                });
            } finally {
                setIsAddBtnLoading(false);
            }
        } else {
            setIsAddBtnLoading(false);
        }
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setIsAddBtnLoading(true);
    //     if (validateForm()) {
    //         try {
    //             const formDataToSend = new FormData();
    //             // Append all form data
    //             Object.keys(formData).forEach(key => {
    //                 if (key === 'applicableCategories' || key === 'excludedDays' || key === 'termsConditions' || key === 'subscriptionWorking' || 
    //                     key === 'excludedOutlets' || key === 'excludedProducts' || key === 'excludedAddonValues') {
    //                     // Format array fields with index notation
    //                     formData[key].forEach((item, index) => {
    //                         const value = typeof item === 'object' ? item._id : item;
    //                         formDataToSend.append(`${key}[${index}]`, value);
    //                     });
    //                 } else if (key === 'applicableOrderValues') {
    //                     // formDataToSend.append('applicableOrderValues[min]', formData.applicableOrderValues.min);
    //                     // if (formData.applicableOrderValues.max) {
    //                     //     formDataToSend.append('applicableOrderValues[max]', formData.applicableOrderValues.max);
    //                     // }
    //                 } else if (key === 'banner' || key === 'otherImage') {
    //                     if (formData[key]) {
    //                         formDataToSend.append(key, formData[key]);
    //                     }
    //                 } else {
    //                     if (formData[key] !== null && formData[key] !== undefined) {
    //                         formDataToSend.append(key, formData[key]);
    //                     }
    //                 }
    //             });

    //             const headers = {
    //                 Authorization: `Bearer ${accessToken}`,
    //                 'Content-Type': 'multipart/form-data'
    //             };
                
    //             const response = await axiosInstance.post("subscription", formDataToSend, { headers });
                
    //             setSubmitStatus({
    //                 success: true,
    //                 message: 'Subscription created successfully!'
    //             });

    //             if (response?.data?.status === true) {
    //                 toast.success(response?.data?.data?.message, {
    //                     position: "top-right",
    //                     autoClose: 3000,
    //                     theme: "light",
    //                 });
    //                 // e.target.reset()
    //             }
                
    //             // Reset form
    //             setFormData({
    //                 title: '',
    //                 subTitle: '',
    //                 description: '',
    //                 termsConditions: [],
    //                 applicableCategories: [],
    //                 excludedDays: [],
    //                 redemptionInterval: '',
    //                 duration: '',
    //                 price: '',
    //                 taxPercent: '',
    //                 banner: null,
    //                 otherImage: null,
    //                 excludedOutlets: [],
    //                 excludedProducts: [],
    //                 excludedAddonValues: [],
    //                 orderThreshold: '',
    //                 orderQuantity: ''
    //             });
                
    //             setPreviewImages({ banner: null, otherImage: null });
    //             setErrors({});
    //             setNewTerm('');
                
    //         } catch (error) {
    //             console.error('Error creating subscription:', error);
    //             setSubmitStatus({
    //                 success: false,
    //                 message: error.response?.data?.message || 'Error creating subscription. Please try again.'
    //             });
    //         } finally {
    //             setIsAddBtnLoading(false);
    //         }
    //     }
    // };

    useEffect(() => {
        getCategoryList();
        getOutletList();
        getProductList();
        getAddonList();
    }, []);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
                    <Row className='mb-4 pt-2'>
                        <Col>
                            <h4 className="fw-semibold mb-0">CREATE NEW SUBSCRIPTION</h4>
                            <p className="text-muted">Fill out the form below to create a new subscription plan</p>
                        </Col>
                        <hr className='mb-0' />
                    </Row>

                    {submitStatus.message && (
                        <Alert variant={submitStatus.success ? 'success' : 'danger'} 
                               onClose={() => setSubmitStatus({...submitStatus, message: ''})} 
                               dismissible>
                            {submitStatus.message}
                        </Alert>
                    )}

                    <Form onSubmit={handleSubmit}>
                        <Card className="mb-4">
                            <Card.Header className="bg-light">
                                <h5 className="mb-0">Basic Information & Images</h5>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Title <span className='text-danger'>*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="title"
                                                placeholder="Enter subscription title"
                                                value={formData.title}
                                                onChange={handleChange}
                                                isInvalid={!!errors.title}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.title}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Subtitle <span className='text-danger'>*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="subTitle"
                                                placeholder="Enter a short subtitle"
                                                value={formData.subTitle}
                                                onChange={handleChange}
                                                isInvalid={!!errors.subTitle}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.subTitle}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs="12" lg="12">
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Description <span className='text-danger'>*</span></Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                name="description"
                                                placeholder="Describe the subscription benefits"
                                                value={formData.description}
                                                onChange={handleChange}
                                                isInvalid={!!errors.description}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.description}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    
                                </Row>

                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>How Does It Works <span className='text-danger'>*</span></Form.Label>
                                            
                                            <div className="mb-3">
                                                <div className="input-group">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Add the workings of the subscription"
                                                        value={newWork}
                                                        onChange={(e) => setNewWork(e.target.value)}
                                                    />
                                                    <Button variant="primary" onClick={addWork}>
                                                        Add
                                                    </Button>
                                                </div>
                                                {errors.subscriptionWorking && (
                                                    <div className="text-danger small mt-1">{errors.subscriptionWorking}</div>
                                                )}
                                            </div>
                                            
                                            {formData?.subscriptionWorking?.length > 0 && (
                                                <ListGroup>
                                                    {formData?.subscriptionWorking?.map((work, index) => (
                                                        <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center">
                                                            {work}
                                                            <Button 
                                                                variant="outline-danger" 
                                                                size="sm" 
                                                                onClick={() => removeWork(index)}
                                                            >
                                                                Remove
                                                            </Button>
                                                        </ListGroup.Item>
                                                    ))}
                                                </ListGroup>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Terms & Conditions <span className='text-danger'>*</span></Form.Label>
                                            <div className="mb-3">
                                                <div className="input-group">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Add a new term & condition"
                                                        value={newTerm}
                                                        onChange={(e) => setNewTerm(e.target.value)}
                                                    />
                                                    <Button variant="primary" onClick={addTerm}>
                                                        Add
                                                    </Button>
                                                </div>
                                                {errors.termsConditions && (
                                                    <div className="text-danger small mt-1">{errors.termsConditions}</div>
                                                )}
                                            </div>
                                            
                                            {formData.termsConditions.length > 0 && (
                                                <ListGroup>
                                                    {formData.termsConditions.map((term, index) => (
                                                        <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center">
                                                            {term}
                                                            <Button 
                                                                variant="outline-danger" 
                                                                size="sm" 
                                                                onClick={() => removeTerm(index)}
                                                            >
                                                                Remove
                                                            </Button>
                                                        </ListGroup.Item>
                                                    ))}
                                                </ListGroup>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>

                                
                                
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Banner Image <span className='text-danger'>*</span></Form.Label>
                                            <Form.Control
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => handleImageChange(e, 'banner')}
                                                isInvalid={!!errors.banner}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.banner}
                                            </Form.Control.Feedback>
                                            {previewImages.banner && (
                                                <div className="mt-2">
                                                    <img 
                                                        src={previewImages.banner} 
                                                        alt="Banner preview" 
                                                        className="img-thumbnail" 
                                                        style={{ maxHeight: '150px' }}
                                                    />
                                                </div>
                                            )}
                                            <Form.Text className="text-muted">
                                                Recommended size: 1200x400px
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Other Image</Form.Label>
                                            <Form.Control
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => handleImageChange(e, 'otherImage')}
                                                isInvalid={!!errors.otherImage}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.otherImage}
                                            </Form.Control.Feedback>
                                            {previewImages.otherImage && (
                                                <div className="mt-2">
                                                    <img 
                                                        src={previewImages.otherImage} 
                                                        alt="Additional image preview" 
                                                        className="img-thumbnail" 
                                                        style={{ maxHeight: '150px' }}
                                                    />
                                                </div>
                                            )}
                                            <Form.Text className="text-muted">
                                                Recommended size: 800x600px
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <Card className="mb-4">
                            <Card.Header className="bg-light">
                                <h5 className="mb-0" >Subscription Details <span className='text-danger'>*</span></h5>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col xs="4" lg="4">
                                        <Form.Label className="fw-semibold">
                                            Subscription Type <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select className='w-100' id="subscriptionType" name="subscriptionType" value={formData?.subscriptionType} onChange={handleChange}>
                                            <option value="" disabled>Select Subscription Type</option>
                                            <option value="DAILY">DAILY</option>
                                            <option value="HOURLY">HOURLY</option>
                                            <option value="UNLIMITED">UNLIMITED</option>
                                        </Form.Select>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Price <span className='text-danger'>*</span></Form.Label>
                                            <div className="input-group">
                                                <span className="input-group-text">₹</span>
                                                <Form.Control
                                                    type="number"
                                                    name="price"
                                                    min="0"
                                                    step="any"
                                                    placeholder="Enter Price"
                                                    value={formData.price}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.price}
                                                />
                                            </div>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.price}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Tax Percentage <span className='text-danger'>*</span></Form.Label>
                                            <div className="input-group">
                                                <Form.Control
                                                    type="number"
                                                    name="taxPercent"
                                                    min="0"
                                                    step="any"
                                                    placeholder="Enter Tax Percent"
                                                    value={formData.taxPercent}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.taxPercent}
                                                />
                                                <span className="input-group-text">%</span>
                                            </div>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.taxPercent}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Redemption Interval (in mins) <span className='text-danger'>*</span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="redemptionInterval"
                                                placeholder="How often can be redeemed"
                                                value={formData.redemptionInterval}
                                                onChange={handleChange}
                                                min="0"
                                                step="any"
                                                isInvalid={!!errors.redemptionInterval}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.redemptionInterval}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Duration (days) <span className='text-danger'>*</span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="duration"
                                                placeholder="Subscription validity period"
                                                value={formData.duration}
                                                min="0"
                                                step="any"
                                                onChange={handleChange}
                                                isInvalid={!!errors.duration}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.duration}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Minimum Order Value and Maximum Order Value */}
                                {/* <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Minimum Order Value <span className='text-danger'>*</span></Form.Label>
                                            <div className="input-group">
                                                <span className="input-group-text">₹</span>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="0.00"
                                                    value={formData.applicableOrderValues.min}
                                                    onChange={(e) => handleNestedChange('applicableOrderValues', 'min', e.target.value)}
                                                    isInvalid={errors.applicableOrderValues?.min}
                                                />
                                            </div>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.applicableOrderValues?.min}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Maximum Order Value</Form.Label>
                                            <div className="input-group">
                                                <span className="input-group-text">₹</span>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Leave empty for no limit"
                                                    value={formData.applicableOrderValues.max}
                                                    onChange={(e) => handleNestedChange('applicableOrderValues', 'max', e.target.value)}
                                                    isInvalid={errors.applicableOrderValues?.max}
                                                />
                                            </div>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.applicableOrderValues?.max}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row> */}

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Order Quantity <span className='text-danger'>*</span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="orderQuantity"
                                                placeholder="Enter maximum orders a user can place"
                                                value={formData.orderQuantity}
                                                onChange={handleChange}
                                                min="0"
                                                step="any"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Order Threshold</Form.Label>
                                            <Form.Control
                                                type="number"
                                                min="0"
                                                step="any"
                                                name="orderThreshold"
                                                placeholder="Enter maximum orders required"
                                                value={formData.orderThreshold}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <Card className="mb-4">
                            <Card.Header className="bg-light">
                                <h5 className="mb-0">Applicability</h5>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Applicable Categories <span className='text-danger'>*</span></Form.Label>
                                            <Select
                                                components={animatedComponents}
                                                isMulti
                                                options={categoryList?.map(category => ({
                                                    value: category?._id,
                                                    label: category?.name
                                                }))}
                                                value={formData?.applicableCategories?.map(cat => ({
                                                    value: cat._id,
                                                    label: cat.name
                                                }))}
                                                onChange={(selectedOptions) => handleSelectChange('applicableCategories', selectedOptions)}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                placeholder="Select categories..."
                                            />
                                            {errors.applicableCategories && (
                                                <div className="text-danger small mt-1">{errors.applicableCategories}</div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Exclude Products</Form.Label>
                                            <Select
                                                components={animatedComponents}
                                                isMulti
                                                options={productList?.map(product => ({
                                                    value: product?._id,
                                                    label: product?.name
                                                }))}
                                                value={formData?.excludedProducts?.map(product => ({
                                                    value: product._id,
                                                    label: product.name
                                                }))}
                                                isDisabled={formData?.applicableCategories?.length === 0}
                                                onChange={(selectedOptions) => handleSelectChange('excludedProducts', selectedOptions)}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                placeholder="Select products to exclude..."
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Exclude Addon Groups</Form.Label>
                                            <Select
                                                components={animatedComponents}
                                                isMulti
                                                options={addonList.map(addon => ({
                                                    value: addon._id,
                                                    label: addon.title
                                                }))}
                                                value={selectedAddonGroups}
                                                onChange={(options) => handleSelectChange('excludedAddonGroups', options)}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                placeholder="Select addon groups..."
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Exclude Addon Values</Form.Label>
                                            <Select
                                                components={animatedComponents}
                                                isMulti
                                                options={filteredAddonValues}
                                                value={formData?.excludedAddonValues?.map(val => ({
                                                value: val,
                                                label: `${addonList.find(a => a._id === val.addonId)?.title || ''} - ${
                                                    addonList
                                                    .find(a => a._id === val.addonId)
                                                    ?.addonValues.find(v => v._id === val.addValueId)?.value || ''
                                                }`
                                                }))}
                                                onChange={(selectedOptions) => {
                                                    // Directly update the formData with the selected values
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        excludedAddonValues: selectedOptions ? selectedOptions.map(opt => opt.value) : []
                                                    }));
                                                }}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                placeholder="Select addon values to exclude..."
                                                getOptionLabel={(option) => option.label}
                                                getOptionValue={(option) => `${option.value.addonId}-${option.value.addValueId}`}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Exclude Outlets</Form.Label>
                                            <Select
                                                components={animatedComponents}
                                                isMulti
                                                options={outletList?.map(outlet => ({
                                                    value: outlet?._id,
                                                    label: `${outlet?.name} - ${outlet?.status}`
                                                }))}
                                                value={formData?.excludedOutlets?.map(outlet => ({
                                                    value: outlet._id,
                                                    label: `${outlet?.name} - ${outlet?.status}`
                                                }))}
                                                onChange={(selectedOptions) => handleSelectChange('excludedOutlets', selectedOptions)}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                placeholder="Select outlets to exclude..."
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Exclude Days (Optional)</Form.Label>
                                            <div className="d-flex flex-wrap gap-2">
                                                {daysOfWeek.map(day => (
                                                    <Form.Check
                                                        key={day}
                                                        type="checkbox"
                                                        id={`day-${day}`}
                                                        label={day}
                                                        checked={formData.excludedDays.includes(day)}
                                                        onChange={(e) => handleCheckboxChange('excludedDays', day, e.target.checked)}
                                                    />
                                                ))}
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                
                            </Card.Body>
                        </Card>

                        {/* <Card className="mb-4">
                            <Card.Header className="bg-light">
                                <h5 className="mb-0">Images</h5>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Banner Image <span className='text-danger'>*</span></Form.Label>
                                            <Form.Control
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => handleImageChange(e, 'banner')}
                                                isInvalid={!!errors.banner}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.banner}
                                            </Form.Control.Feedback>
                                            {previewImages.banner && (
                                                <div className="mt-2">
                                                    <img 
                                                        src={previewImages.banner} 
                                                        alt="Banner preview" 
                                                        className="img-thumbnail" 
                                                        style={{ maxHeight: '150px' }}
                                                    />
                                                </div>
                                            )}
                                            <Form.Text className="text-muted">
                                                Recommended size: 1200x400px
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Additional Image <span className='text-danger'>*</span></Form.Label>
                                            <Form.Control
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => handleImageChange(e, 'otherImage')}
                                                isInvalid={!!errors.otherImage}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.otherImage}
                                            </Form.Control.Feedback>
                                            {previewImages.otherImage && (
                                                <div className="mt-2">
                                                    <img 
                                                        src={previewImages.otherImage} 
                                                        alt="Additional image preview" 
                                                        className="img-thumbnail" 
                                                        style={{ maxHeight: '150px' }}
                                                    />
                                                </div>
                                            )}
                                            <Form.Text className="text-muted">
                                                Recommended size: 800x600px
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card> */}

                        <hr />
                        <div className="d-flex justify-content-end gap-2 pb-3">
                            {/* <Button variant="outline-secondary">
                                Cancel
                            </Button> */}
                            <Button variant="primary" type="submit">
                                { isAddBtnLoading ? <Spinner size='sm' /> : 'Create Subscription' }
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AddSubscription;